<div class="flex-1 mt-4">
  <h2 class="mb-1" data-tour="chart-accounts-title">Define your Chart of Accounts</h2>
  <p class="mb-8 mt-0 text-night-lighter">Map your financial line items to your accounting system accounts</p>

  <sbnb-loading-spinner *ngIf="(formState$ | async)?.loading"></sbnb-loading-spinner>

  <!-- Financial Line Items -->
  <div class="w-full" data-element="accounts-mapping-container" formGroupName="accounts">
    <ng-container *ngIf="groupedAccountsToMap$ | async as groupedAccountsToMap">
      <ng-container *ngFor="let category of groupedAccountsToMap | keyvalue: compareCategories">
        <div class="flex flex-col w-full gap-2 pb-5" [attr.data-element]="'category-' + category">
          <h3 class="m-0">{{ category.key | humanize }}</h3>

          <ng-container>
            <div class="flex justify-between items-center w-full" *ngFor="let account of category.value">
              <div class="text__small">
                {{ account.label }}
              </div>
              <sbnb-statements-accounting-connection-form-account-dropdown
                *ngIf="accountsOptions$ | async as options"
                [formControlName]="account.reference"
                [availableAccounts]="options[account.category] || []"
                [accountClass]="account.category"
                [accountName]="account.label"
                [accountReference]="account.reference"></sbnb-statements-accounting-connection-form-account-dropdown>
            </div>
          </ng-container>
          <mat-divider></mat-divider>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
